export default {"src":"/_next/static/media/local_shipping.b8abf8f4.svg","height":13,"width":19,"blurWidth":0,"blurHeight":0};